/**
 * Esta funcion añade estilos de manera dinamica a la clase .swap-bg--syncSwiper
 */
const historySwiper = () => {
    syncSwiperBg();
    addPaginationYear();
};

function syncSwiperBg() {
    // Inicializa el fondo al color del primer slide
    addSyncedCss(getActiveSlideIndex());

    // Configura un MutationObserver para observar cambios en el DOM
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.target.classList.contains('swiper-slide-active')) {
                addSyncedCss(getActiveSlideIndex());
            }
        });
    });

    // Configura el observador para observar cambios de atributos en los slides
    var config = { attributes: true, subtree: true, attributeFilter: ['class'] };
    var slidesContainer = document.querySelector('.swiper-wrapper');
    if (slidesContainer) {
        observer.observe(slidesContainer, config);
    }
}
function addPaginationYear(){
    // Esperar a que el Swiper esté completamente inicializado
    const swiperContainer = document.querySelector('.elementor-element[swap-bg="syncSwiper"]');
    const observer = new MutationObserver(() => {
        if (swiperContainer.querySelector('.swiper-pagination-bullet')) {
            const bullets = swiperContainer.querySelectorAll('.swiper-pagination-bullet');
            const slides = swiperContainer.querySelectorAll('.swiper-slide > .elementor-element');

            bullets.forEach((bullet, index) => {
                if (slides[index]) {
                    const year = slides[index].getAttribute('data-year');
                    bullet.setAttribute('data-year', year);
                }
            });

            // Dejar de observar después de que los bullets se hayan configurado
            observer.disconnect();
        }
    });

    if( swiperContainer ) {
        observer.observe(swiperContainer, { childList: true, subtree: true });
    }
}
// Función para actualizar el color de fondo
function addSyncedCss(index) {
    var colors = ['light-gray', 'light-brown']; // Define los colores para par e impar
    var color = colors[index % 2]; // Selecciona el color basado en si el índice es par o impar

    // Busca una etiqueta de estilo existente o crea una nueva
    var styleElement = document.getElementById('dynamic-background-color');
    if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'dynamic-background-color';
        document.head.appendChild(styleElement);
    }

    // Actualiza la regla CSS para .swap-bg
    styleElement.innerHTML = `.swap-bg--syncSwiper { --syncedBg: var(--${color}) !important; }`;
}

// Función para obtener el índice del slide activo
function getActiveSlideIndex() {
    var activeSlide = document.querySelector('.elementor-element[swap-bg="syncSwiper"] .swiper-slide-active');
    if (activeSlide) {
        var slides = Array.from(activeSlide.parentElement.children);
        return slides.indexOf(activeSlide);
    }
    return 0;
}


export default historySwiper;